import { Container, SizableText, YStack, Stack, colors } from '@my/ui'
import { H2 } from 'app/components'
import { Frown } from '@tamagui/lucide-icons'

export const SearchNoResults = () => {
  return (
    <Container>
      <YStack p="$4" gap="$3" flex={1} justifyContent="center" alignItems="center">
        <Stack
          p="$2"
          backgroundColor="$white"
          borderRadius={100_100}
          shadowColor="black"
          shadowOpacity={0.16}
          shadowOffset={{ width: -1, height: 2 }}
          shadowRadius={8}
        >
          <Frown color={colors.primary} size={48} />
        </Stack>
        <H2 textAlign="center">Sorry, there's no matches for your search</H2>
        <SizableText textAlign="center" size="$5" color="$grey6">
          But don't stop here - Try less specific search terms and check the spelling.
        </SizableText>
      </YStack>
    </Container>
  )
}
